import React from 'react';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { getCardSystemLogo } from '@/components/Payment/PaymentMethods.helpers';
import * as S from '@/components/Payment/PaymentMethods.styles';
import { PaymentMethod } from '@/api/types/payments.types';
import { UserCard } from '@/api/types/user.types';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';

type Props = {
  card: UserCard;
  isSelected: boolean;
  cardsButtonLabel: string;
  onSelect: () => void;
  onOpenCards: React.MouseEventHandler;
  order?: number;
};

export function SavedCardOption({
  card,
  isSelected,
  cardsButtonLabel,
  onSelect,
  onOpenCards,
  order,
}: Props) {
  return (
    <S.ListItem
      dataTestId={PaymentMethod.My_card}
      onChangeHook={onSelect}
      value={isSelected}
      label={card.name}
      $order={order}
      labelIcon={
        <IconBox
          $filename={`${getCardSystemLogo(card)}.png`}
          $width={45}
          $height={30}
          $iconWidth={34}
        />
      }
      labelPosition="right"
      action={
        <S.CheckboxAction
          $variant="1"
          onClick={onOpenCards}
          data-testid={AdPageTestIds.myCards.triggerButton}
        >
          {cardsButtonLabel}
        </S.CheckboxAction>
      }
      appearance="radio"
      size="sm"
      color="secondary"
      hasBorderBottom={false}
    />
  );
}
